import React from 'react'
import { Box, Grid, Tooltip, Typography } from '@mui/material'
import InputField from '../../../../FormControl/input/InputField'
import { SelectMultipleFieldYears } from '../../../../FormControl/SelectRequest/SelectMultipleFieldYears'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FormBasicInformation = ({ onChange, form = {}, errors = {}, showTitle }) => {
  const permission = useSelector((state) => state?.session?.permissions?.class.updated || [])
  return (
    <>
      {showTitle && (
        <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center'>
          <Typography variant='inherit' className='font-bold capitalize' component='p'>
            Basic Information
          </Typography>
        </Box>
      )}
      <Box className={showTitle ? 'px-4 py-4' : ''}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Code
            </Typography>
          </Grid>
          <Grid item sm={9}>
            {permission?.includes('basic-information') ? (
              <InputField
                id='code'
                name='code'
                error={errors.code}
                helperText={errors.code}
                value={form.code}
                onChange={(e) => onChange('code', e.target.value)}
              />
            ) : (
              <Typography>{form?.code}</Typography>
            )}
          </Grid>
          <Grid item sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Name
            </Typography>
          </Grid>
          <Grid item sm={9}>
            {permission?.includes('basic-information') ? (
              <InputField
                id='name'
                name='name'
                error={errors.name}
                helperText={errors.name}
                value={form.name}
                onChange={(e) => onChange('name', e.target.value)}
              />
            ) : (
              <Typography>{form?.name}</Typography>
            )}
          </Grid>
          <Grid item sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Description
            </Typography>
          </Grid>
          <Grid item sm={9}>
            {permission?.includes('basic-information') ? (
              <InputField
                id='description'
                name='description'
                error={errors.description}
                helperText={errors.description}
                value={form.description}
                onChange={(e) => onChange('description', e.target.value)}
                multiline={true}
              />
            ) : (
              <Typography>{form?.description}</Typography>
            )}
          </Grid>
          <Grid item sm={3} className='flex items-center justify-end'>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Year level
            </Typography>
            {errors?.warningYearLevel && (
              <Tooltip arrow title={errors?.warningYearLevel}>
                <FontAwesomeIcon icon={['fal', 'warning']} className='text-primary px-1' />
              </Tooltip>
            )}
          </Grid>
          <Grid item sm={9}>
            <SelectMultipleFieldYears
              id='yearLevel'
              name='yearLevel'
              error={errors.yearLevel}
              helperText={errors.yearLevel}
              value={form.yearLevel}
              onChange={(e) => onChange('yearLevel', e.target.value)}
              isPreview={
                form?._id
                  ? form?.unitOfLearnings?.length > 0
                    ? true
                    : !permission?.includes('year-level')
                  : false
              }
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default FormBasicInformation
